// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.completed-check {
  display: block !important;
}
.stepper-item.current .completed-check {
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/layout/profile/enable-two-factor-authentication-modal.component.less"],"names":[],"mappings":"AAAA;EACI,yBAAA;AACJ;AAEA;EACI,WAAA;AAAJ","sourcesContent":[".completed-check {\n    display: block !important;\n}\n\n.stepper-item.current .completed-check {\n    color: #fff;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
